// src/components/Layout.tsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/layout.css";
import korridor_logo_white from "../assets/korridor_logo_white.png";
import fuelsureLogo from "../assets/fuelsure_logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import { clearUserSession, validateSession } from "../functions/utils/util_functions";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        // Check if user is logged in or redirect to login page
        const isValidSession = validateSession();
        if (!isValidSession) {
            navigate('/login');
        }
    }, [navigate]);


    const handleLogout = () => {
        // Add logout logic here
        clearUserSession()
        navigate("/login");
    };

    return (
        <div className="layout">
            <header className="header">

                {/* Hamburger Toggle Button */}
                <button className="toggle-button" onClick={() => setSidebarOpen(!sidebarOpen)}>
                    <MenuIcon className="hamburger-icon" />
                </button>

                {/* Added the Fuelsure Logo */}
                <img src={korridor_logo_white} alt="Logo" className="logo" />

                <button className="logout-button" onClick={handleLogout}>Logout</button>
            </header>

            <div className="main">
                <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
                    {sidebarOpen && (
                    <>                    
                        <ul className="menu">
                            {/* <li onClick={() => navigate("/")}>Home</li> */}
                            {/* <li onClick={() => navigate("/transactions")}>Transactions</li> */}
                            <li onClick={() => navigate("/disptrans")}>Dispensed Transactions</li>
                            <li onClick={() => navigate("/disptranslevel")}>Tank Levels vs Dispensed</li>
                            <li onClick={() => navigate("/outflowcomp")}>Outflow Comparison</li>
                            <li onClick={() => navigate("/receives")}>Received Transactions</li>
                            <li onClick={() => navigate("/recondaily")}>Recon Daily Snapshot</li>
                            <li onClick={() => navigate("/shiftreport")}>Shift Report</li>
                            {/* <li onClick={() => navigate("/settings")}>Settings</li> */}
                        </ul>
                            {/* Sidebar Footer */}
                            <div className="sidebar-footer">
                            <span>Powered by</span>
                            <img src={fuelsureLogo} alt="FuelSure Logo" className="sidebar-logo" />
                            </div>
                    </>
                    )}
                </aside>
                <main className="content">{children}</main>
            </div>
        </div>
    );
};

export default Layout;
